__turbopack_context__.v({
  "block": "oikbwW_block",
  "emphasis": "oikbwW_emphasis",
  "strikeThrough": "oikbwW_strikeThrough",
  "underline": "oikbwW_underline",
});
